var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "wrapper-selector", attrs: { fill: "white" } },
    [
      _c("defs", [
        _c(
          "filter",
          { attrs: { id: "shadow" } },
          [
            _c("feDropShadow", {
              attrs: {
                dx: "0",
                dy: "4",
                stdDeviation: "4",
                "flood-opacity": ".5"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "mask" } }, [
          _c("circle", {
            attrs: {
              r: _vm.selector / 2,
              cx: _vm.coordinates.x,
              cy: _vm.coordinates.y
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("circle", {
        staticClass: "selector",
        attrs: {
          "stroke-width": "2",
          stroke: "#FFFFFF",
          filter: "url(#shadow)",
          r: _vm.selector / 2,
          cx: _vm.coordinates.x,
          cy: _vm.coordinates.y
        }
      }),
      _vm._v(" "),
      _c("image", {
        attrs: {
          opacity: ".5",
          width: "100%",
          height: "100%",
          preserveAspectRatio: "none",
          href: _vm.src
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }